import FieldGroupColumn from './Groups/FieldGroupColumn';

type FieldGroupType = {
  Col: typeof FieldGroupColumn;
};
const FieldGroup: FieldGroupType = {
  Col: FieldGroupColumn,
};
export default FieldGroup;
